<script setup lang="ts">
import type { IProps } from './RadioButton.types'

defineProps<IProps>()
const model = defineModel<IProps['modelValue']>('modelValue')
</script>

<template>
  <label
    class="radioButton"
    :class="{ 'radioButton--error': error }"
    :for="id"
  >
    <span class="radioButton__label">
      {{ label }}
    </span>

    <input
      :id="id"
      v-model="model"
      class="radioButton__input"
      type="radio"
      :value="value"
    >
  </label>
</template>

<style lang="scss" scoped>
.radioButton {
  $root: &;
  display: flex;
  align-items: center;
  gap: 1.4rem;
  height: 4.8rem;
  padding: 0 2.8rem;
  background-color: $white;
  border: 1px solid $gray-400;
  border-radius: 1.8rem;
  cursor: pointer;

  &--error {
    border-color: $invalid-500;
  }

  &__label {
    @include body-3-medium;
    order: 1;
    color: $text-300;
  }

  &__input {
    width: 1.2rem;
    height: 1.6rem;
    background-image: url('/icons/forms/radio-button-empty.svg');
    background-repeat: no-repeat;
    background-position: center;

    &:checked {
      background-image: url('/icons/forms/radio-button-checked.svg');
    }
  }
}
</style>
